import React from 'react';

import DashMod_MatchResults01 from './comps/DashMod_MatchResults01';
import DashMod_GameResultsPlayerAll01 from './comps/DashMod_GameResultsPlayerAll01';
import DashMod_GameResultsPlayerComp01 from './comps/DashMod_GameResultsPlayerComp01';

class playerDashboardOptB extends React.Component {

  constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				<DashMod_MatchResults01 playerId={this.props.playerId} resultsType={this.props.resultsType} leagueType={this.props.leagueType}/>
     		<DashMod_GameResultsPlayerAll01 playerId={this.props.playerId} resultsType={this.props.resultsType} leagueType={this.props.leagueType}/>
     		<DashMod_GameResultsPlayerComp01 playerId={this.props.playerId} resultsType={this.props.resultsType} leagueType={this.props.leagueType}/>
   		</div>
		)
	}
	
}

export default playerDashboardOptB;
